export default __webpack_public_path__ + "static/media/filterIconNew.888b6625.svg";